import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import {
	Card,
	CardContent,
	CardActions,
	Avatar,
	Typography,
	Button,
	colors
} from '@mui/material';
import getInitials from 'utils/getInitials';
import { UpdateImage } from '../../../../../../actions/OperatorsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		textAlgin: 'center',
	},
	name: {
		marginTop: theme.spacing(1),
	},
	avatar: {
		height: 120,
		width: 120,
	},
	removeButton: {
		width: '100%',
		color: theme.palette.error.main
	},
	addButton: {
		width: '100%',
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Picture = (props) => {
	const { operator, className, ...rest } = props;

	const classes = useStyles();
	const dispatch = useDispatch();
	const inputFile = useRef(null);

	const _removeImage = () => {
		const updateOperator = { ...operator };
		updateOperator.avatar = null;
		dispatch(UpdateImage(updateOperator));
	};

	const _addImage = () => {
		inputFile.current.click();
	};

	const _onChangeInput = (event) => {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.addEventListener('load', () => {
				const updateOperator = { ...operator };
				updateOperator.avatar = reader.result;
				dispatch(UpdateImage(updateOperator));
			}
			);
			reader.readAsDataURL(event.target.files[0]);
		}
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardContent className={classes.content}>
				<Avatar className={classes.avatar} src={operator.avatar}>
					{getInitials(operator.name)}
				</Avatar>
			</CardContent>
			<CardActions>
				{operator.avatar === null ? (
					<Button className={classes.addButton} variant="contained" onClick={_addImage}>
						Add picture
					</Button>
				) : (
					<Button className={classes.removeButton} variant="text" onClick={_removeImage}>
						Remove picture
					</Button>
				)}
			</CardActions>
			<input id="file" type="file" accept="image/png" ref={ref => { inputFile.current = ref; }} onChange={_onChangeInput} style={{ display: 'none' }} />
		</Card>
	);
};

Picture.propTypes = {
	className: PropTypes.string,
	operator: PropTypes.object.isRequired,
};

export default Picture;
